<template>
  <div class="page-cases">
    <router-view v-if="$route.name.includes('.summary')" :selected-year="selectedYear" />

    <template v-else>
      <div class="row mb-3">
        <div class="col px-2 d-flex gap-2">
          <div class="case-search bg-semi-transparent rounded d-flex align-items-center px-3 flex-grow-1">
            <i class="fa fa-magnifying-glass text-light me-3" aria-hidden="true"></i>
            <input
              type="text"
              v-model="searchQuery"
              class="form-control bg-transparent border-0 text-light shadow-none"
              placeholder="Search by Serial No., Project Name, Road Name"
            />
            <button
              v-if="searchQuery"
              type="button"
              class="btn btn-sm text-light"
              @click="searchQuery = ''"
              aria-label="Clear search"
            >
              <i class="fa fa-xmark" aria-hidden="true"></i>
            </button>
          </div>
          <button
            type="button"
            class="sort-flip btn bg-semi-transparent rounded text-light d-flex align-items-center px-3 text-nowrap"
            @click="sortDesc = !sortDesc"
            :aria-label="sortDesc ? 'Sort oldest first' : 'Sort newest first'"
          >
            <i
              class="fa me-2"
              :class="sortDesc ? 'fa-arrow-down-wide-short' : 'fa-arrow-up-wide-short'"
              aria-hidden="true"
            ></i>
            {{ sortDesc ? "Newest first" : "Oldest first" }}
          </button>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col px-2">
          <div class="filter-container d-flex rounded">
            <div class="filter-items">
              <div class="dropdown h-100">
                <button class="btn dropdown-toggle h-100 w-100 text-light" type="button" id="dropdownMenuButton"
                  data-bs-toggle="dropdown" aria-expanded="false">
                  <div class="w-100 h-100 d-flex">
                    <div class="h-100 d-flex align-items-center">
                      <i class="fa fa-angle-down mx-2" aria-hidden="true"></i>
                    </div>
                    <div class="text-start ms-2 d-flex flex-column align-items-start justify-content-center">
                      <p class="mb-0">Districts</p>
                      <p class="fw-bold mb-0">
                        {{
                          selectedDistrict
                            ? selectedDistrict.name
                            : "All District"
                        }}
                      </p>
                    </div>
                  </div>
                </button>
                <ul class="dropdown-menu bg-dark" aria-labelledby="dropdownMenuButton">
                  <li>
                    <button class="dropdown-item text-light" @click="selectedDistrict = null"
                      :class="{ 'text-success': !selectedDistrict }">
                      All District
                    </button>
                  </li>
                  <li v-for="district in allDistricts" :key="district.id">
                    <button class="dropdown-item text-light" @click="selectedDistrict = district">
                      {{ district.name }}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div class="filter-items">
              <div class="dropdown h-100">
                <button class="btn dropdown-toggle h-100 w-100 text-light" type="button" id="dropdownMenuButton"
                  data-bs-toggle="dropdown" aria-expanded="false">
                  <div class="w-100 h-100 d-flex">
                    <div class="h-100 d-flex align-items-center">
                      <i class="fa fa-angle-down mx-2" aria-hidden="true"></i>
                    </div>
                    <div class="text-start ms-2 d-flex flex-column align-items-start justify-content-center">
                      <p class="mb-0">Roads</p>
                      <p class="fw-bold mb-0">
                        {{
                          selectedRoad
                            ? selectedRoad.name
                            : "All Road"
                        }}
                      </p>
                    </div>
                  </div>
                </button>
                <ul class="dropdown-menu bg-dark overflow-auto" style="max-height: 50vh;"
                  aria-labelledby="dropdownMenuButton">
                  <li>
                    <button class="dropdown-item text-light" @click="selectedRoad = null"
                      :class="{ 'text-success': !selectedRoad }">
                      All Road
                    </button>
                  </li>
                  <li v-for="road in computedRoadFilter" :key="road.id">
                    <button class="dropdown-item text-light" @click="selectedRoad = road">
                      {{ road.name }}
                    </button>
                  </li>
                </ul>
              </div>
            </div>

            <div class="filter-items" v-if="$route.name == 'cases.site-visit-list'">
              <div class="dropdown h-100">
                <button class="btn dropdown-toggle h-100 w-100 text-light" type="button" id="dropdownMenuButton"
                  data-bs-toggle="dropdown" aria-expanded="false">
                  <div class="w-100 h-100 d-flex">
                    <div class="h-100 d-flex align-items-center">
                      <i class="fa fa-angle-down mx-2" aria-hidden="true"></i>
                    </div>
                    <div class="text-start ms-2 d-flex flex-column align-items-start justify-content-center">
                      <p class="mb-0">Type</p>
                      <p class="fw-bold mb-0">
                        {{
                          selectedType
                            ? selectedType
                            : "All Type"
                        }}
                      </p>
                    </div>
                  </div>
                </button>
                <ul class="dropdown-menu bg-dark" aria-labelledby="dropdownMenuButton">
                  <li>
                    <button class="dropdown-item text-light" @click="selectedType = null">
                      All Type
                    </button>
                  </li>
                  <li v-for="type in types" :key="type">
                    <button class="dropdown-item text-light" @click="selectedType = type">
                      {{ type == "KJP" ? "NOD" : type }}
                    </button>
                  </li>
                </ul>
              </div>
            </div>

            <div class="filter-items" v-if="
              $route.name.includes('.site-visit-list') &&
              Helper.jkrRoles.includes(user.role)
            ">
              <div class="dropdown h-100">
                <button class="btn dropdown-toggle h-100 w-100 text-light" type="button" id="dropdownMenuButton"
                  data-bs-toggle="dropdown" aria-expanded="false">
                  <div class="w-100 h-100 d-flex">
                    <div class="h-100 d-flex align-items-center">
                      <i class="fa fa-angle-down mx-2" aria-hidden="true"></i>
                    </div>
                    <div class="text-start ms-2 d-flex flex-column align-items-start justify-content-center">
                      <p class="mb-0">Site Visit Status</p>
                      <p class="fw-bold mb-0 text-capitalize">
                        {{ selectedStatus || "All Status" }}
                      </p>
                    </div>
                  </div>
                </button>
                <ul class="dropdown-menu bg-dark" aria-labelledby="dropdownMenuButton">
                  <li>
                    <button class="dropdown-item text-light" @click="selectedStatus = null">
                      All Status
                    </button>
                  </li>
                  <li v-for="status in statuses" :key="`select-status-${status}`">
                    <button class="dropdown-item text-light text-capitalize" @click="selectedStatus = status">
                      {{ status }}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="case-item justify-content-center text-secondary fst-italic" v-if="computedNods.length == 0">
        No case found
      </div>
      <div class="row">
        <div class="col-12 col-md-6 p-2" v-for="nod in computedNods" :key="`case-${nod.id}`">
          <div class="case-item align-items-start h-100 mb-0 flex-column flex-md-row flex-wrap position-relative">
            <div class="position-absolute top-0 end-0 d-flex align-items-center gap-2 p-3">
              <span class="blink" v-if="
                user &&
                Helper.jkrRoles.includes(user.role) &&
                nod.nod_bq &&
                !nod.nod_bq.isRead
              ">
                <i class="fa-solid fa-circle text-info" />
              </span>
              <span
                v-if="showUrgency && urgencyTier(nod)"
                class="urgency-pill"
                :class="urgencyTier(nod)"
                :title="urgencyTier(nod)"
              >
                {{ urgencyLabel(nod) }}
              </span>
            </div>
            <div class="d-flex align-items-start">
              <div class="flex-shrink-0">
                <div class="case-image bg-light" v-if="nod.photos && nod.photos.length">
                  <img v-if="Helper.getCaseImage(nod.photos)" :src="Helper.getCaseImage(nod.photos)" class="clickable"
                    @click="openMediaPreview(nod.photos)" />
                </div>
              </div>
              <div class="flex-grow-1 ms-3">
                <p class="fw-bold mb-0 text-wrap text-break text-secondary">
                  # {{ nod.serialNo }}
                </p>
                <p class="fw-bold mb-0">
                  {{ nod.typeOfDefect }}
                </p>
                <div class="pt-2 pb-3">
                  <case-status-badge :case-status="nod.componentStatus" :group-type="nod.groupType" class="me-3" />
                  <span class="badge bg-light text-dark px-3" v-if="nod.groupType">
                    {{ nod.groupType == 'KJP' ? 'NOD' : nod.groupType }}
                  </span>
                </div>
                <p class="small mb-0">
                  {{
                    Helper.formatDate(nod.timestamp, false)
                      ? Helper.formatDate(nod.timestamp, false)
                      : "Date not set"
                  }}
                </p>

                <p class="small mb-0">
                  {{
                    nod.road ? getRoadName(nod.road) + ", " : "Road not set, "
                  }}
                  {{ getDistrictName(nod.district) || "District not set" }}
                </p>
                <p class="small mb-0 fw-bold" v-if="nod.cases && nod.cases.length">
                  {{ nod.cases.length }} related to this NOD
                </p>
              </div>
            </div>
            <div class="align-self-end mt-3 mt-md-0 p-3 ms-auto">
              <router-link :to="{ name: 'case-details', params: { id: nod.id } }"
                class="btn btn-sm btn-secondary rounded-pill text-nowrap px-3">
                <i class="fa-solid fa-eye me-2" />
                View
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <media-viewer :url="currentMedia" v-if="currentMedia" @close="currentMedia = null" />
    </template>
  </div>
</template>

<script>
import CaseStatusBadge from "@/components/CaseStatusBadge";
import MediaViewer from "@/components/MediaViewer";

export default {
  name: "page-cases",
  components: { CaseStatusBadge, MediaViewer },
  props: ["selectedYear"],
  data() {
    return {
      groupType: null,
      nodCases: [],
      currentMedia: null,
      allDistricts: [],
      allRoads: [],
      statuses: ["new", "submitted"],
      types: ["KJP", "Electrical", "Emergency"],
      selectedDistrict: null,
      selectedRoad: null,
      selectedStatus: null,
      selectedType: null,
      searchQuery: "",
      sortDesc: false,
      user: {},
    };
  },
  watch: {
    "$route.name": {
      async handler() {
        this.selectedType = null;

        this.groupType =
          !this.$route.name.startsWith("cases.") &&
            !this.$route.name.startsWith("work-order.")
            ? this.$route.name.split(".")[0]
            : "kjp";

        this.user = JSON.parse(localStorage.getItem("user") || {});

        this.selectedStatus = null;

        await this.getDistricts();

        this.getNod();
      },
      immediate: true,
    },
    selectedYear() {
      this.getNod();
    },
    selectedDistrict() {
      this.selectedRoad = null;
      this.getNod();
    },
    selectedRoad() {
      this.getNod();
    },
    selectedType() {
      this.getNod();
    },
  },
  computed: {
    computedRoadFilter() {
      if (!this.selectedDistrict) return this.allRoads;

      return (
        this.allDistricts.find(
          (district) => district.id == this.selectedDistrict.id
        )?.roads || []
      );
    },
    computedNods() {
      let _nodCases = JSON.parse(JSON.stringify(this.nodCases));

      switch (this.selectedStatus) {
        case "new":
          _nodCases = _nodCases.filter(
            (nod) =>
              !nod.componentStatus?.site_visit &&
              nod.componentStatus?.site_visit !== "pending"
          );
          break;
        case "submitted":
          _nodCases = _nodCases.filter(
            (nod) => nod.componentStatus?.site_visit === "pending"
          );
          break;
        default:
          break;
      }

      if (this.searchQuery && this.searchQuery.trim()) {
        const q = this.searchQuery.trim().toLowerCase();

        _nodCases = _nodCases.filter((nod) => {
          const roadName = this.getRoadName(nod.road) || "";

          return (
            nod.serialNo?.toLowerCase().includes(q) ||
            nod.typeOfDefect?.toLowerCase().includes(q) ||
            roadName.toLowerCase().includes(q)
          );
        });
      }

      const toMs = (t) => {
        const m = t ? this.Helper.moment(t) : null;
        return m && m.isValid() ? m.valueOf() : null;
      };

      _nodCases.sort((a, b) => {
        const ta = toMs(a.timestamp);
        const tb = toMs(b.timestamp);

        if (ta === null && tb === null) return 0;
        if (ta === null) return 1; // missing/invalid dates sink to the bottom
        if (tb === null) return -1;

        return this.sortDesc ? tb - ta : ta - tb;
      });

      return _nodCases;
    },
    showUrgency() {
      const name = this.$route.name || "";

      return !(
        name.includes(".completed") ||
        name.includes(".approved") ||
        name.includes(".rejected")
      );
    },
  },
  methods: {
    getDistrictName(id) {
      return this.allDistricts.find((district) => district.id == id)?.name;
    },
    getRoadName(id) {
      return this.allRoads.find((road) => road.id == id)?.name;
    },
    caseAgeDays(nod) {
      if (!nod.timestamp) return null;

      const created = this.Helper.moment(nod.timestamp).startOf("day");

      if (!created.isValid()) return null;

      return this.Helper.moment().startOf("day").diff(created, "days");
    },
    urgencyTier(nod) {
      const days = this.caseAgeDays(nod);

      if (days === null) return null;
      if (days <= 14) return "fresh";
      if (days <= 30) return "aging";

      return "overdue";
    },
    urgencyLabel(nod) {
      const days = this.caseAgeDays(nod);

      if (days === null) return "";
      if (days <= 0) return "today";
      if (days === 1) return "1 day ago";

      return `${days} days ago`;
    },
    openMediaPreview(media) {
      if (!media || media.length == 0) return;

      this.currentMedia = this.Helper.getCaseImage(media);
    },
    async getDistricts() {
      this.Helper.toggleLoadingSpinner(true);

      let url = this.API.endpoints().allDistricts;

      if (this.user.districts.length) {
        this.user.districts.forEach((district) => {
          url += `&id_in=${district.id}`;
        });
      }

      this.allDistricts = [];
      this.allRoads = [];

      const [call, error] = await this.Helper.handlePromise(this.API.get(url));

      if (error) {
        console.error(error);
      } else {
        this.allDistricts = call.data;

        const _allRoads = [];

        call.data.forEach((district) => {
          _allRoads.push(district.roads);
        });

        this.allRoads = _allRoads.flat();
      }

      return;
    },
    getNod() {
      this.Helper.toggleLoadingSpinner(true);

      return new Promise(async (resolve, reject) => {
        let url = this.API.endpoints(this.selectedYear).allCases.concat(
          "&_sort=createdAt:DESC"
        );

        if (this.groupType && !this.$route.name.includes(".site-visit-list")) {
          url += `&groupType_contains=${this.groupType}`;
        }

        if (this.selectedDistrict) {
          url += `&district=${this.selectedDistrict.id}`;
        } else {
          if (this.user.districts.length) {
            this.user.districts.forEach((district) => {
              url += `&district_in=${district.id}`;
            });
          }
        }

        if (this.selectedRoad) {
          url += `&road=${this.selectedRoad.id}`;
        }

        if (this.selectedType) {
          url += `&groupType=${this.selectedType}`;
        }

        const [call, error] = await this.Helper.handlePromise(
          this.API.get(url)
        );

        if (error) {
          console.error(error);

          reject(error);
        } else {
          let _nodCases = call.data.filter(cd => !cd.isRejected);

          if (this.$route.name.includes(".rejected")) {
            _nodCases = call.data.filter((cd => cd.isRejected));
          } else if (this.$route.name == "work-order.list") {
            _nodCases = _nodCases.filter(
              (nod) =>
                nod.componentStatus?.bq &&
                nod.componentStatus?.site_visit === true &&
                (!nod.componentStatus?.memo || !nod.componentStatus?.claim)
            );
          } else if (this.$route.name.includes(".site-visit-list")) {
            _nodCases = _nodCases.filter(
              (nod) => nod.componentStatus?.site_visit !== true
            );
          } else if (this.$route.name.includes(".bq-list")) {
            _nodCases = _nodCases.filter(
              (nod) =>
                nod.componentStatus?.site_visit === true &&
                !nod.componentStatus?.bq
            );
          } else if (this.$route.name.includes(".pending-ak")) {
            _nodCases = _nodCases.filter((nod) => !nod.componentStatus?.jkr_wo);
          } else if (this.$route.name.includes(".pending-wo")) {
            if (this.$route.meta?.hideFor?.includes(this.user.role)) {
              this.$router.replace({ name: "work-order.pending-ak" });
            }

            _nodCases = _nodCases.filter((nod) => !nod.componentStatus?.wo);
          } else if (this.$route.name.includes(".pending-site-diary")) {
            _nodCases = _nodCases.filter(
              (nod) => !nod.componentStatus?.site_diary
            );
          } else if (this.$route.name.includes(".pending-payment")) {
            _nodCases = _nodCases.filter(
              (nod) => !nod.componentStatus?.claim || !nod.componentStatus?.memo
            );
          } else if (this.$route.name.includes(".completed")) {
            _nodCases = _nodCases.filter(
              (nod) => nod.componentStatus?.claim && nod.componentStatus?.memo
            );
          } else if (this.$route.name.includes(".approved")) {
            if (['electrical', 'emergency'].includes(this.groupType?.toLowerCase())) {
              _nodCases = _nodCases.filter(
                (nod) =>
                  nod.componentStatus?.site_visit === true &&
                  nod.componentStatus?.bq
              );
            } else {
              _nodCases = _nodCases.filter(
                (nod) =>
                  nod.componentStatus &&
                  this.Helper.allCaseStatuses.others.every(
                    (s) => nod.componentStatus && nod.componentStatus[s]
                  )
              );
            }
          } else {
            _nodCases = [];
          }

          this.nodCases = _nodCases;

          resolve();
        }

        this.Helper.toggleLoadingSpinner(false);
      });
    },
  },
};
</script>